import { Injectable, inject } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { ENVIRONMENT } from '@models';
import { resolveFunctionsBaseUrl } from './functions-base-url';
@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  environment = inject<any>(ENVIRONMENT);
  private readonly firebaseApp = inject(FirebaseApp);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCalendar(teamId: string): Promise<any> {
    // Llamada DIRECTA a la Cloud Function (no `${projectId}.web.app`, que es el
    // site por defecto sin el rewrite `/downloadcalendar`; el rewrite vive en el
    // site admin en este repo multi-site). Mismo patrón que certificate.service.
    // El projectId sale de la Firebase app ya inicializada, para respetar el
    // toggle dev/pro en runtime de `apps/app`.
    const BASE_URL = resolveFunctionsBaseUrl(this.firebaseApp, this.environment);
    const tenantId = this.environment.tenantId;
    const url =
      BASE_URL + `downloadcalendar?teamId=${teamId}&tenantId=${tenantId}`;
    window.open(url, '_blank');
    return Promise.resolve();
  }
}
